import { useState, useEffect } from 'react';
import { apiService, getStorageUrl } from '../../../../services/apiService';
import { useTenant } from '../../../../contexts/TenantContext';

const ThrowballAbout = () => {
  const { siteSettings } = useTenant();
  const [aboutData, setAboutData] = useState({
    title: 'About Us',
    content: '',
    image: null
  });
  const [loading, setLoading] = useState(true);

  // Static/Default content - shown when no dynamic data exists
  const staticContent = `
    <p>A non - contact ball sport played across a net between two teams of nine players each side out of 12 players on a rectangular court is known as "Throwball Game".</p>
    <p>Dr. Harry Crowe Buck who was father of Scientific Physical Education in India and Founder of Young Men Christian Association's College of Physical Education of Madras in the year 1920.</p>
    <p>With keen interest and through the entire efforts of Prof. Jagat Singh Chauhan of Haryana, India, who's also a Founder of 'Handball Federation of India', formed "THROWBALL FEDERATION OF INDIA" on 15th January, 1978 in Madan Mohan Malviya Stadium, Allahabad and since then Haryana, Gujarat, Uttar Pradesh, Madhya Pradesh, Maharashtra, Delhi, Punjab and Rajasthan State Throwball Associations are striving hard by organizing competition at National level to promote and develop this game in India and abroad also. Mrs. Shashi Prabha of Haryana had taken a lead to organise its "FIRST NATIONAL THROWBALL CHAMPIONSHIP" in Jind, Haryana in 1978. In which Delhi Team (Men Team) became the WINNER during this Championships. After that Mrs. Zineeth Fernando of Colombo, Sri Lanka imparted Coaching to Indian Team on the grounds of Government College, Jind, Haryana in May, 1982 for fortnight. Her services were spared by the Director of Sports, SriLanka. Finally, after the incentive coaching to the Indian Team, a successful tour programmed to Sri Lanka was organised in month of August, 1982.</p>
  `;

  useEffect(() => {
    fetchAboutData();
  }, []);

  const fetchAboutData = async () => {
    try {
      setLoading(true);
      const response = await apiService.get('/public/site-settings');

      if (response.data?.success && response.data?.data) {
        const data = response.data;
        setAboutData({
          title: data.data.about_title || 'About Us',
          content: data.data.about_content || staticContent,
          image: getStorageUrl(data.data.about_image)
        });
      } else {
        setAboutData({
          title: 'About Us',
          content: staticContent,
          image: null
        });
      }
    } catch (error) {
      console.error('Error fetching about data:', error);
      setAboutData({
        title: 'About Us',
        content: staticContent,
        image: null
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="tb-page-section tb-about-section">
      <div className="tb-container">
        {/* Top Banner */}
        <div className="tb-page-banner">
          <img src={siteSettings?.page_banners?.about || '/theme/assets/images/banner-2.jpg'} alt="About Us Banner" />
        </div>

        {/* Page Content */}
        <div className="tb-page-content">
          <div className="tb-heading-top">
            <h1 className="tb-page-title">{aboutData.title}</h1>
            <span className="tb-mini-line"></span>
          </div>

          {loading ? (
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <p>Loading...</p>
            </div>
          ) : (
            <>
              {aboutData.image && (
                <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
                  <img
                    src={aboutData.image}
                    alt="About Us"
                    style={{ maxWidth: '100%', height: 'auto', borderRadius: '8px' }}
                  />
                </div>
              )}
              <div
                className="tb-content-text"
                style={{ whiteSpace: 'pre-wrap', lineHeight: '1.8' }}
                dangerouslySetInnerHTML={{ __html: aboutData.content }}
              />
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default ThrowballAbout;
